<template>
    <a
        href="#!"
        @click.prevent="openCheckout"
        class="paddle_button"
        :class="extraClass"
    >
        <slot></slot>
    </a>
</template>

<script setup>
import { onMounted } from "vue";
import { initializePaddle } from "@paddle/paddle-js";

const props = defineProps({
    checkout: {
        type: Object,
        required: true,
    },
    clientToken: {
        type: String,
        required: true,
    },
    environment: {
        type: String,
        required: false,
        default: "sandbox", // 'sandbox' or 'production'
    },
    extraClass: {
        type: String,
        required: false,
        default: "",
    },
});

const openCheckout = async () => {
    try {
        const paddleInstance = await initializePaddle({
            environment: props.environment,
            token: props.clientToken,
        });
        if (!paddleInstance) {
            console.error("Paddle not initialized");
            return;
        }
        const rawCheckout = JSON.parse(JSON.stringify(props.checkout));
        const checkoutOptions = {
            ...rawCheckout,
            settings: {
                ...rawCheckout.settings,
                displayMode: "overlay",
                frameStyle: undefined,
            },
        };
        paddleInstance.Checkout.open(checkoutOptions);
    } catch (e) {
        console.error("Failed to open Paddle checkout", e);
    }
};
</script>
